import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';
import PlaceholderPage from '@/modules/common/components/PlaceholderPage';

// Sprint 6: CampanasPage and DescripcionComercialPage removed — smarthub-marketing retired.
// Campaign engine will be rebuilt natively in stratos-growth (Sprint 8+).
const CampanasPlaceholder = () => (
  <PlaceholderPage title="Campañas" description="Motor de campañas en migración a stratos-growth (Sprint 8)" />
);

const ContenidoComercialPlaceholder = () => (
  <PlaceholderPage title="Contenido Comercial" description="Gestión de perfiles comerciales, fichas de programa y material de ventas" />
);

const RedesSocialesPlaceholder = () => (
  <PlaceholderPage title="Redes Sociales" description="Gestión de cuentas sociales, calendario de contenido y LinkedIn Sales Navigator" />
);

const DescripcionComercialPlaceholder = () => (
  <PlaceholderPage title="Descripción Comercial" description="Gestión de descripciones comerciales de programas" />
);

const AnalyticsPlaceholder = () => (
  <PlaceholderPage title="Analytics de Marketing" description="Métricas end-to-end, atribución multitouch y funnel de conversión" />
);

export const marketingRoutes = [
  // Campañas (placeholder — engine migrating to stratos-growth Sprint 8)
  <Route key="/marketing/campanas" path="/marketing/campanas" element={
    <Navigate to="/marketing/campanas/leads" replace />
  } />,
  <Route key="/marketing/campanas/leads" path="/marketing/campanas/leads" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><CampanasPlaceholder /></ProtectedRoute>
  } />,
  <Route key="/marketing/campanas/landing" path="/marketing/campanas/landing" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><CampanasPlaceholder /></ProtectedRoute>
  } />,
  <Route key="/marketing/campanas/motor" path="/marketing/campanas/motor" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><CampanasPlaceholder /></ProtectedRoute>
  } />,
  <Route key="/marketing/campanas/ads" path="/marketing/campanas/ads" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><CampanasPlaceholder /></ProtectedRoute>
  } />,
  <Route key="/marketing/campanas/analytics" path="/marketing/campanas/analytics" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><CampanasPlaceholder /></ProtectedRoute>
  } />,

  // Redes Sociales (placeholder)
  <Route key="/marketing/redes-sociales" path="/marketing/redes-sociales" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><RedesSocialesPlaceholder /></ProtectedRoute>
  } />,

  // Contenido Comercial (placeholder)
  <Route key="/marketing/contenido" path="/marketing/contenido" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><ContenidoComercialPlaceholder /></ProtectedRoute>
  } />,

  // Descripción Comercial (placeholder)
  <Route key="/marketing/descripcion-comercial" path="/marketing/descripcion-comercial" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><DescripcionComercialPlaceholder /></ProtectedRoute>
  } />,

  // Analytics (placeholder)
  <Route key="/marketing/analytics" path="/marketing/analytics" element={
    <ProtectedRoute requiredPermission="marketing.campaigns.view"><AnalyticsPlaceholder /></ProtectedRoute>
  } />,
];
